module.exports = __webpack_public_path__ + "static/img/541617348155.f8bd1af5.jpg";